/*
 * @Description: 
 * @Date: 2025-06-23 14:28:46
 * @LastEditors: function
 * @LastEditTime: 2025-10-23 18:06:44
 * @FilePath: \protal-web\src\router\index.js
 */
import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [
        {
            name: '',
            path: '/',
            component: () => import(/* webpackChunkName: "home" */ '@/views/home/index.vue'),
        },
        {
            name: '',
            path: '*',
            redirect: '/'
        },
        // {
        //     name: 'news',
        //     path: '/news',
        //     component: () => import(/* webpackChunkName: "news" */ '@/views/news/index.vue'),
        // },
        {
            name: 'newsList',
            path: '/news/list',
            component: () => import(/* webpackChunkName: "news" */ '@/views/news/list.vue'),
        },
        {
            name: 'newsDetails',
            path: '/news/details',
            component: () => import(/* webpackChunkName: "news" */ '@/views/news/details.vue'),
        },
        {
            name: 'contact',
            path: '/contact',
            component: () => import(/* webpackChunkName: "contact" */ '@/views/contact/index.vue'),
        },
        {
            name: 'project',
            path: '/project/line',
            component: () => import(/* webpackChunkName: "project" */ '@/views/project/index.vue'),
        },
        {
            name: 'declare',
            path: '/project/declare',
            component: () => import(/* webpackChunkName: "project" */ '@/views/project/declare.vue'),
        },
        {
            name: 'msg',
            path: '/project/msg',
            component: () => import(/* webpackChunkName: "project" */ '@/views/project/msg.vue'),
        },
        {
            name: 'szlk',
            path: '/project/szlk',
            component: () => import(/* webpackChunkName: "project" */ '@/views/project/szlk.vue'),
        },
        {
            name: 'middle',
            path: '/middle.html',
            component: () => import(/* webpackChunkName: "project" */ '@/views/middle/index.vue'),
        }
    ],

    scrollBehavior(to, from, savedPosition) {
        // 如果使用浏览器后退/前进按钮，返回保存的位置
        if (savedPosition) {
            return savedPosition;
        } else {
            // 否则滚动到顶部
            return { x: 0, y: 0 };
        }
    },
})

// 解决重复点击导航时，控制台出现报错
const RouterPush = Router.prototype.push
Router.prototype.push = function push (to) {
    return RouterPush.call(this, to).catch(err => err)
}